import { Observable, of } from 'rxjs';
import { Injectable } from '@angular/core';

@Injectable()
export class MobileAuthService {
  public store(key: string, value: string): Observable<boolean> {
    if (!window.Bridge) return of(false);

    return new Observable<boolean>(observer => {
      window.Bridge!.keystore.store(key, value, false, res => {
        console.log('store', key, value, res.success);
        observer.next(res.success);
        observer.complete();
      });
    });
  }

  public retrieve(key: string): Observable<string | undefined> {
    if (!window.Bridge) return of(undefined);

    return new Observable<string | undefined>(observer => {
      window.Bridge!.keystore.retrieve(key, res => {
        console.log('retrieve', key, res, res.data?.value);
        observer.next(res.data?.value);
        observer.complete();
      });
    });
  }
}
